var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tab',{staticClass:"LayoutNavbarHorizontalItem",attrs:{"to":_vm.to ? { name: _vm.to } : null}},[_c('div',{staticClass:"LayoutNavbarHorizontalItem__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }